// extracted by mini-css-extract-plugin
export default {"container":"BorderedTag_container__lXQp0","type-danger":"BorderedTag_type-danger__x+tMG"};